@if (ui$ | async; as ui) {
  @if (ui.jobs.length > 0) {
    <div
      class="pointer-events-auto fixed z-[100] flex w-[min(100vw-2rem,22rem)] flex-col overflow-hidden rounded-xl border border-border bg-background shadow-lg ring-1 ring-black/5 dark:ring-white/10 bottom-4 right-4"
      role="status"
      aria-live="polite"
    >
      <div
        class="flex shrink-0 items-center justify-between gap-2 border-b border-border px-3 py-2"
      >
        <span class="text-sm font-semibold text-foreground truncate pr-2">
          {{ 'units.knowledgeBase.exportPdfPanelStackTitle' | transloco }}
          <span class="text-muted-foreground font-normal"
            >({{ ui.jobs.length }})</span
          >
        </span>
        <div class="flex shrink-0 items-center gap-0.5">
          <button
            size="icon"
            type="button"
            hlmBtn
            variant="ghost"
            size="icon-sm"
            (click)="svc.toggleStackMinimized()"
            [attr.aria-label]="
              ui.stackMinimized
                ? ('units.knowledgeBase.exportPdfPanelExpand' | transloco)
                : ('units.knowledgeBase.exportPdfPanelMinimize' | transloco)
            "
          >
            @if (ui.stackMinimized) {
              <ng-icon name="lucideChevronUp" size="18" />
            } @else {
              <ng-icon name="lucideChevronDown" size="18" />
            }
          </button>
          <button
            size="icon"
            type="button"
            hlmBtn
            variant="ghost"
            size="icon-sm"
            (click)="svc.dismissAllJobs()"
            [attr.aria-label]="
              'units.knowledgeBase.exportPdfPanelDismissAll' | transloco
            "
          >
            <ng-icon name="lucideX" size="18" />
          </button>
        </div>
      </div>

      @if (!ui.stackMinimized) {
        <!-- ~4 visible rows (15rem); scroll when more -->
        <ul
          class="pdf-export-dl-list m-0 max-h-[15rem] list-none overflow-y-auto overflow-x-hidden p-0"
        >
          @for (job of ui.jobs; track trackJob($index, job)) {
            <li
              class="flex min-h-[3.5rem] items-start gap-3 border-b border-border px-3 py-2.5 last:border-b-0"
            >
              <span
                class="inline-flex h-8 w-5 shrink-0 items-center justify-center self-start"
                aria-hidden="true"
              >
                <ng-icon
                  name="lucideFileDown"
                  size="18"
                  [class.text-muted-foreground]="job.phase === 'working'"
                  [class.text-primary]="job.phase === 'done'"
                  [class.text-destructive]="job.phase === 'error'"
                />
              </span>
              <div class="min-w-0 flex-1 pt-px">
                @if (job.phase === 'done' && job.filename) {
                  <p
                    class="text-sm font-medium leading-tight text-foreground truncate"
                    [title]="job.filename"
                  >
                    {{ job.filename }}
                  </p>
                  <p
                    class="mt-0.5 text-xs leading-tight text-muted-foreground line-clamp-2"
                  >
                    {{
                      'units.knowledgeBase.exportPdfPanelDownloadsHint'
                        | transloco
                    }}
                  </p>
                } @else {
                  <p class="text-sm leading-snug text-foreground line-clamp-2">
                    {{ job.statusKey | transloco: job.statusParams ?? {} }}
                  </p>
                }
              </div>
              <!-- Fixed min width so dismiss stays aligned when only one control (error) -->
              <div
                class="flex min-w-[4.5rem] shrink-0 items-center justify-end gap-0.5 self-start"
              >
                @if (job.phase === 'done' && job.blobUrl) {
                  <button
                    size="icon"
                    type="button"
                    hlmBtn
                    variant="ghost"
                    size="icon-sm"
                    class="shrink-0"
                    (click)="openJob(job)"
                    [attr.aria-label]="
                      'units.knowledgeBase.exportPdfPanelOpenFile' | transloco
                    "
                  >
                    <ng-icon name="lucideExternalLink" size="18" />
                  </button>
                }
                @if (job.phase === 'working') {
                  <div
                    class="flex h-8 w-8 shrink-0 items-center justify-center"
                    aria-hidden="true"
                  >
                    <hlm-spinner size="sm" class="shrink-0 scale-90" />
                  </div>
                }
                <button
                  size="icon"
                  type="button"
                  hlmBtn
                  variant="ghost"
                  size="icon-sm"
                  class="shrink-0"
                  (click)="svc.removeJob(job.id)"
                  [attr.aria-label]="
                    'units.knowledgeBase.exportPdfPanelClose' | transloco
                  "
                >
                  <ng-icon name="lucideX" size="16" />
                </button>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  }
}
